import React from 'react';
import { LoadingSpinnerIcon } from '../icons';

type LoadingWidgetProps = {
    message?: string;
};

export const LoadingWidget: React.FC<LoadingWidgetProps> = ({ message = 'Loading...' }) => (
    <div style={{ textAlign: 'center', color: '#6b7280' }}>
        <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center' }}>
            <LoadingSpinnerIcon />
        </div>
        <p style={{ fontSize: '16px', fontWeight: 500, margin: 0 }}>{message}</p>
    </div>
);
